import { format } from "date-fns";
import Joi from "joi";
import { Dropdown, Spinner } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import Form from "react-bootstrap/Form";
import select from "@/assets/img/selectOption.svg";
import { useContext, useEffect, useState } from "react";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { BudgetContext } from "@/page-components/budgets/budget.context";
import { ReportingContext } from "../reporting-context-file";
import idlestyles from "@/page-components/idle-resource/idle.module.css";
import nextIcon from "@/assets/img/savingNextIcon.svg";
import previousIcon from "@/assets/img/savingPrevYearIcon.svg";
import calender_side_arrow from "@/assets/img/calender_side_arrow.svg";
import styles from "@/page-components/reporting/reporting.module.css";

export const CreateAllCloudReport = (context) =>
  Joi.object({
    NAME: Joi.string().required().messages({
      "string.empty": "Report name is required",
      "any.required": "Report name is required",
    }),
    // group_by: Joi.string().required().messages({
    //   "any.required": "Group By is required",
    //   "string.empty": "Group By is required",
    //   // "string.base": "Group by must be a string",
    // }),

    // group_by: Joi.string(),
    group_by: Joi.string().allow("").optional(),
    Tags: Joi.string(),
    Dimension: Joi.string(),

    PERIOD: Joi.string()
      // .valid(
      //   "LAST_WEEK",
      //   "THIS_WEEK",
      //   "THIS_MONTH",
      //   "LAST_MONTH",
      //   "THIS_QUARTER",
      //   "CUSTOM"
      // )
      .required()
      .messages({
        "string.empty": "Period is required",
        "any.required": "Period is required",
      }),
    // from_date: Joi.when("PERIOD", {
    //   is: "CUSTOM",
    //   then: Joi.string().required().messages({
    //     "any.required": "Date Range is required",
    //     "string.empty": "Date Range is required",
    //   }),
    // }),

    Frequency: Joi.string()
      // .valid("ONE_TIME", "WEEKLY", "MONTHLY")
      .required()
      .messages({
        "string.empty": "Frequency is required",
        "any.required": "Frequency is required",
      }),

    ALERTS_RECEIPIENTS: Joi.array()
      .items(
        Joi.string()
          .email({ tlds: { allow: false } })
          .messages({
            "string.email": "Each recipient must be a valid email",
          })
      )
      .min(1)
      .required()
      .messages({
        "array.min": "Alert recipients is required",
        "array.base": "Alert recipients is required",
        "array.empty": "Alert recipients is required",
        "any.required": "Alert recipients are required",
      }),

    // ---------------------------------------------------------

    from_date: Joi.when("PERIOD", {
      is: "CUSTOM",
      then: Joi.string().required().messages({
        "any.required": "From Date is required",
        "string.empty": "From Date is required",
      }),
      otherwise: Joi.string().optional().allow("", null),
    }),

    to_date: Joi.when("PERIOD", {
      is: "CUSTOM",
      then: Joi.string().required().messages({
        "any.required": "To Date is required",
        "string.empty": "To Date is required",
      }),
      otherwise: Joi.string().optional().allow("", null),
    }),
  });

// ---------------------------------------------------------------------------------------------

export const SelectField = (props) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const filterTags = (tags) => {
    if (!searchQuery) return tags;
    return tags.filter((tag) =>
      (tag.name || tag.id || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  };

  const filteredTags = filterTags(props.commonFieldData || []);
  const { rules } = props || {};
  const { onSelect = () => {} } = props;

  return (
    <div className="accountid_box">
      <div className="accountid_name" style={{ cursor: "not-allowed" }}>
        {props.title} {props.unit ? props.unit : " "}
        <span className="astriek_css">
          {props.title !== "Dimension" && props.title !== "Tags" && <b>*</b>}
        </span>
      </div>

      <div style={{ display: "flex", position: "relative" }}>
        <Controller
          control={props.control || ""}
          name={props.fieldName || ""}
          rules={rules}
          render={({ field: { value, onChange } }) => (
            <>
              <Dropdown
                className="input_box_css"
                style={{ width: props?.CustomWidth === true ? "270px" : "" }}
                onSelect={(selected) => {
                  onChange(selected);
                  onSelect(selected);
                }}
                onToggle={(isOpen) => {
                  if (!props?.disabled) {
                    setIsDropdownOpen(isOpen);
                    if (isOpen) setSearchQuery("");
                  }
                }}
              >
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-basic"
                  className="dropdown_Toggel"
                  disabled={
                    props?.disabled ||
                    props?.disableOption ||
                    props?.disableValue
                  }
                >
                  <span style={!value ? { color: "#ADB5BD" } : {}}>
                    {value
                      ? (props.commonFieldData || []).find(
                          (e) => e.id === value
                        )?.name
                      : props?.placeholder}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="alligment" id="insetStyles">
                  {props.search && (
                    <Form.Control
                      autoFocus
                      type="search"
                      className="w-100 mb-2"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  )}

                  {props?.isLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <Spinner />
                    </div>
                  ) : (
                    <div
                      style={{
                        overflowY: filteredTags.length > 15 ? "scroll" : "",
                        maxHeight: "450px",
                      }}
                    >
                      {filteredTags.map((e) => (
                        <Dropdown.Item key={e.id} eventKey={e.id}>
                          {e?.name || e?.id || "--"}
                        </Dropdown.Item>
                      ))}

                      {filteredTags.length === 0 && (
                        <div style={{ textAlign: "center", padding: "10px" }}>
                          No {props?.title} found.
                        </div>
                      )}
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        />
        <img
          style={{ position: "absolute", right: "10px", top: "13px" }}
          src={select}
          width={"10px"}
          height={"10px"}
          alt="icon"
        />
      </div>

      <div
        style={{
          height: "10px",
          display: "flex",
          marginBottom: props?.title === "Frequency" ? "16px" : "0px",
        }}
      >
        {rules?.message && (
          <span className="budgetsError">{rules.message}</span>
        )}
      </div>
    </div>
  );
};

export const DropdownComponent = ({
  options,
  onSelect,
  title,
  onToggle,
  isOpen,
  extraButton,
  children,
  dropdownRef,
  disabled,
  rules,
}) => {
  const context = useContext(ReportingContext);
  useEffect(() => {
    context?.setTitlePeriod(title);
  }, [title, context]);
  return (
    <div className="accountid_box" style={{ marginTop: "-10px" }}>
      <div className="accountid_name" style={{ cursor: "not-allowed" }}>
        Period
        <span className="astriek_css">
          <b>*</b>
        </span>
      </div>
      <div className={styles.dropdown_custom}>
        <button
          type="button"
          className={styles.dropdown_custom_button}
          onClick={onToggle}
          disabled={disabled}
          style={{
            border: "1px solid var(--Neutral-D6, #ced4da)",
            width: "330px",
          }}
        >
          <span style={{ opacity: !!disabled ? "0.5" : "1" }}>{title}</span>
          <span style={{ paddingLeft: "10px" }}>
            <img src={calender_side_arrow} alt="icon"></img>
          </span>
        </button>
        {isOpen && !disabled && (
          <div
            ref={dropdownRef}
            className={styles.dropdown_menuss}
            style={
              {
                // width: context?.dropdownView === "customRange" ? "300px" : "190px",
              }
            }
          >
            {options.map((option, index) => (
              <button
                key={index}
                className={styles.dropdown_itemed}
                onClick={() => {
                  onSelect(option);
                  onToggle();
                }}
              >
                {option}
              </button>
            ))}
            {extraButton.label === "Custom Month Range" && (
              <div
                style={{
                  borderTop: "1px solid #F8F9FA",
                  marginBottom: "4px",
                  marginTop: "4px",
                }}
              ></div>
            )}
            {extraButton && (
              <button
                className={styles.dropdown_itemed}
                // style={{ marginTop: "4px", borderTop: "1px solid #F8F9FA" }}
                onClick={() => {
                  extraButton.onClick?.();
                }}
              >
                {extraButton.imgBefore && (
                  <img
                    src={previousIcon}
                    alt=""
                    style={{ paddingRight: "10px" }}
                  />
                )}
                {extraButton.label}
                {extraButton.imgAfter && (
                  <img src={nextIcon} alt="" style={{ paddingLeft: "19px" }} />
                )}
              </button>
            )}
            {children}
          </div>
        )}
      </div>
      {rules?.from_date && (
        <p className="budgetsError">{rules.from_date.message}</p>
      )}
      {rules?.to_date && (
        <p className="budgetsError">{rules.to_date.message}</p>
      )}
    </div>
  );
};
